/*@ngInject*/
const UIAutoExpandDirective = function () {

    let linkFunction = function ($scope, $elm) {

        function autoExpand(event) {
            let element = event.target;
            if (element) {
                let scrollHeight = element.scrollHeight;
                element.style.height = scrollHeight + 'px';
            }
        }

        $scope.$on('$destroy', function () {
            $elm.unbind('keyup', autoExpand);
            $elm.unbind('focus', autoExpand);
        });

        $elm.bind('keyup', autoExpand);
        $elm.bind('focus', autoExpand);
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('umCore')
    .directive('uiAutoExpand', UIAutoExpandDirective);
